/** Story-card placeholder: square thumbnail beside three text bars. */

import { Pad } from 'component/basics';
import { StyleSheet, View } from 'react-native';

import { BaseSkeleton } from './base-skeleton';
import { TextContainerSkeleton } from './text-container-skeleton';

export function StoryCardSkeleton() {
    const s = StoryCardSkeletonStyle;
    return (
        <View style={s.container}>
            <BaseSkeleton borderRadius={8} height={70} marginRight={20} width={70} />
            <View style={s.textContainer}>
                <TextContainerSkeleton borderRadius={2} height={6} />
                <Pad size={8} />
                <TextContainerSkeleton borderRadius={2} height={6} />
                <Pad size={20} />
                <TextContainerSkeleton borderRadius={2} height={6} width={80} />
            </View>
        </View>
    );
}

const StoryCardSkeletonStyle = StyleSheet.create({
    container: { flexDirection: 'row' },
    textContainer: { flex: 1, paddingTop: 12 },
});
